export default "__VITE_ASSET__5b20dfb4__"